import { SelectClearable } from "ui";
import { ActionIcon, Group, TextInput, rem, Checkbox } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { useDebouncedCallback } from "use-debounce";
import { useState } from "react";
import { DatePickerInput } from "@mantine/dates";
import { useAppTranslation } from "hooks/useTranslation";

interface EventsSearchFilterProps {
  title: string;
  type?: number;
  dateRange?: [Date | null, Date | null];
  organizer?: string;
  organizerEvents: boolean;
  organizers: { uid: string; name: string }[];
  onUpdateTitle?: (title: string) => void;
  onUpdateType?: (type?: number) => void;
  onUpdateDateRange?: (dateRange?: [Date | null, Date | null]) => void;
  onUpdateOrganizer?: (organizer?: string) => void;
  onUpdateOrganizerEvents?: (checked: boolean) => void;
}

const DropDownBreak = "--------------";

export const EventsSearchFilter = (props: EventsSearchFilterProps) => {
  const {
    title,
    dateRange,
    organizer,
    organizerEvents,
    organizers,
    onUpdateTitle,
    onUpdateDateRange,
    onUpdateOrganizer,
    onUpdateOrganizerEvents,
  } = props;
  const { t } = useAppTranslation();
  const [titleInput, setTitleInput] = useState(title);
  const [value, setValue] = useState<[Date | null, Date | null]>(
    dateRange || [null, null]
  );
  const debouncedTitle = useDebouncedCallback(
    (value) => {
      onUpdateTitle && onUpdateTitle(value);
    },
    // delay in ms
    500
  );

  const updateDateRange = (dateRange?: [Date | null, Date | null]) => {
    setValue(dateRange || [null, null]);
    onUpdateDateRange && onUpdateDateRange(dateRange);
  };

  const updateOrganizer = (organizer: string | null) => {
    if (organizer === DropDownBreak) {
      return;
    }
    onUpdateOrganizer &&
      onUpdateOrganizer(organizer === null ? undefined : organizer);
  };
  return (
    <Group>
      <TextInput
        value={titleInput}
        label=""
        placeholder={t("events.event_title")}
        leftSection={<IconSearch style={{ width: rem(16), height: rem(16) }} />}
        onChange={(event) => {
          debouncedTitle(event.currentTarget.value);
          setTitleInput(event.currentTarget.value);
        }}
        rightSection={
          <>
            {titleInput.length > 0 && (
              <ActionIcon
                variant="transparent"
                onClick={() => {
                  setTitleInput("");
                  onUpdateTitle && onUpdateTitle("");
                }}
              >
                <IconX size={15} />
              </ActionIcon>
            )}
          </>
        }
      />
      <DatePickerInput
        type="range"
        placeholder={t("events.date_range")}
        clearable
        value={value}
        onChange={updateDateRange}
      />
      <SelectClearable
        value={organizer}
        placeholder={t("events.organizer")}
        data={[
          // "all",
          t("events.municipalities"),
          t("events.organizers"),
          "--------------",
          ...organizers?.map((user) => user.name),
        ]}
        onChange={updateOrganizer}
      />
      <Checkbox
        label={t("events.organizer_events")}
        checked={organizerEvents}
        onChange={(event) =>
          onUpdateOrganizerEvents?.(event.currentTarget.checked)
        }
      />
    </Group>
  );
};
